var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, memo } from "react";
import { Box, List } from "@material-ui/core";
import { useLayoutConsumers } from "../provider";
import NavCollapse from "./navCollapse";
import NavItem from "./navitem";
import { LogoSvg } from "./svg/iran_airtour_en";
import { LogoMoileSvg } from "./svg/logoMobile";
import { useStyles } from "./styles";
import BottomList from "./bottomList";
var DrawerList = memo(function (props) {
    var _a = useLayoutConsumers(), open = _a.menu.open, menuToggle = _a.menuToggle, bottomItemOpen = _a.bottomItemOpen, floatMenuToggle = _a.floatMenuToggle;
    var classes = useStyles();
    return (_jsxs(Box, __assign({ className: classes.container }, { children: [_jsxs(Box, { children: [open ? (_jsx(Box, __assign({ className: classes.mainImg, onClick: function () {
                            menuToggle();
                            floatMenuToggle(true);
                        } }, { children: LogoSvg }))) : (_jsx(Box, __assign({ className: classes.mobileImg, onClick: function () { return floatMenuToggle(true); } }, { children: LogoMoileSvg }))), _jsx(List, __assign({ className: classes.list }, { children: props.menus.map(function (route) {
                            var _a;
                            return (route === null || route === void 0 ? void 0 : route.showMenu) &&
                                (route === null || route === void 0 ? void 0 : route.hasAccess) && (_jsx(Fragment, { children: ((_a = route.children) === null || _a === void 0 ? void 0 : _a.length) ? ((route === null || route === void 0 ? void 0 : route.children.some(function (child) { return child === null || child === void 0 ? void 0 : child.hasAccess; })) ? (_jsx(NavCollapse, __assign({}, route, { currentPath: props.currentPath, onRouteChange: props.onRouteChange }))) : null) : (_jsx(NavItem, __assign({}, route, { currentPath: props.currentPath, onRouteChange: props.onRouteChange }))) }, route === null || route === void 0 ? void 0 : route.title));
                        }) }))] }), (props === null || props === void 0 ? void 0 : props.bottomItems) ? (_jsx(BottomList, { bottomItems: props === null || props === void 0 ? void 0 : props.bottomItems, openDrawer: bottomItemOpen, menuToggle: menuToggle })) : null] })));
});
export { DrawerList };
